import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';

import { StyledCellFormatter } from '~src/spacesPlatform/components/ListView/StyledCellWrapper';

import { AlertIconWithUber } from '../../../../extractTask/components/AlertInfo';

export interface IAlert {
  type: string;
}

export function AlertCell(alertFn: (row: DataGrid.Row) => IAlert): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      function AlertIconWithUberPopup(props: BodyCell.Props): JSX.Element {
        const {row} = props;
        const alert = alertFn(row);
        const id = row.data['id'];
        const hasAlert = row.data['hasAlert'];

        return <>
          {hasAlert &&
          <AlertIconWithUber
              iconButtonStyle={{cursor: 'pointer', margin: '2px', verticalAlign: 'middle'}}
              id={id}
              tabindex={-1}
              type={alert.type}
          />}
        </>;
      }
  );
}
